<template>
  <div style='height: 100%'>
    <!-- 工具栏 -->
    <div class='navbar'>
      <el-button type='primary' icon='sys sys-refresh' class='navbarbtn'
        @click='deepRefreshMainTableContent'>
        刷 新
      </el-button>

      <el-button type='primary' icon='sys sys-time' class='navbarbtn' v-if='showBatchNoChangePower'
        @click='showBatchNoChangeDialogMD()'>
        批号调整申请
      </el-button>

      <el-button type='primary' icon='sys sys-check' class='navbarbtn' v-if='showCheckPower'
        @click='checkICC'>
        审 核
      </el-button>

      <el-button type='danger' icon='sys sys-cancelcheck' class='navbarbtn' v-if='showUnCheckPower'
        @click='cancelCheckICC'>
        反审核
      </el-button>

      <ExportExcel @click='mainTableExportExcel'></ExportExcel>

      <el-button type='primary' icon='sys sys-expand' class='navbarbtn'
        @click='mainTableExpandRow'>
        展 开
      </el-button>

      <el-button type='primary' icon='sys sys-narrow' class='navbarbtn'
        @click='mainTableNarrowRow'>
        收 起
      </el-button>

      <TableColumnSet :columnSetLoading='mainTable.ColumnSetLoading'
        :showColumnSetDialog='mainTable.showColumnSetDialog'
        :changeShowColumnSetDialog='mainTable.changeShowColumnSetDialog'
        :columnInfo='mainTable.userColumnInfo'
        :tableInfo='mainTable.userTableInfo'
        @updateUserColumnSetDialogReset='mainTableUpdateUserColumnSetDialogReset'
        @saveUserTableColumn='mainTableSaveUserTableColumn'
        @returnDefaultTableColumn='mainTableReturnDefaultTableColumn'
        @showColumnSetDialogMD='mainTableShowColumnSetDialogMD'>
      </TableColumnSet>

      <TableFilterSet :filterSetLoading='mainTable.FilterSetLoading'
        :showFilterSetDialog='mainTable.showFilterSetDialog'
        :changeShowFilterSetDialog='mainTable.changeShowFilterSetDialog'
        :filterInfo='mainTable.userFilterInfo'
        :columnInfo='mainTable.columnInfo'
        @updateUserFilterDialogReset='mainTableUpdateUserFilterDialogReset'
        @saveUserTableFilter='mainTableSaveUserTableFilter'
        @returnDefaultTableFilter='mainTableReturnDefaultTableFilter'
        @showFilterSetDialogMD='mainTableShowFilterSetDialogMD'>
      </TableFilterSet>

      <TableFilter :filterLoading='mainTable.FilterLoading'
        :showFilterDialog='mainTable.showFilterDialog'
        :changeShowFilterDialog='mainTable.changeShowFilterDialog'
        :filterInfo='mainTable.filterInfo'
        :columnInfo='mainTable.columnInfo'
        :getSpecialStringArray='mainTableGetSpecialStringArray'
        @showFilterDialogMD='mainTableShowFilterDialogMD'
        @filter='mainTableFilter'>
      </TableFilter>

      <TableFilterOutDisplay v-for='oneFilterInfo in mainTable.filterInfo'
        :key='oneFilterInfo.ColumnCode + oneFilterInfo.FilterType'
        :getSpecialStringArray='mainTableGetSpecialStringArray'
        :columnInfo='mainTable.columnInfo'
        :oneFilterInfo='oneFilterInfo' @filter='mainTableFilter'>
      </TableFilterOutDisplay>

      <el-input v-model='mainTable.itemNumber' style='width: 125px;' placeholder='物料代码'
        @keyup.enter.native='mainTableFilter()' size='mini' class='filterInput' suffix-icon=''></el-input>

      <el-input v-model='mainTable.itemName' style='width: 125px;' placeholder='物料名称'
        @keyup.enter.native='mainTableFilter()' size='mini' class='filterInput' suffix-icon=''></el-input>

      <el-input v-model='mainTable.qrCode' style='width: 125px;' placeholder='内箱标签号'
        @keyup.enter.native='mainTableFilter()' size='mini' class='filterInput' suffix-icon=''></el-input>
    </div>

    <Table :data='mainTable.tableContent' :tableInfo='mainTable.tableInfo'
      :columnInfo='mainTable.columnInfo' :disPlayColumnInfo='mainTable.disPlayColumnInfo'
      :page-size='mainTable.pageSize' :page='mainTable.page'
      :total='mainTable.total' v-loading='mainTable.Loading'
      :reduceHeight='200' :seqFixed='true'
      :row-style='mainTableRowStyle'
      :showOperationsColumn='true' operationColumnWidth='130px'
      :expandRowKeys='mainTable.expandRowKeys'
      :showDefaultExpandColumn='false' :showExpandColumn='true'
      :getSpecialStringArray='mainTableGetSpecialStringArray'
      @selection-change='mainTableSelectionChange'
      @page-change='mainTablePageChange' @size-change='mainTableSizeChange'
      @sort-change='mainTableSortChange'>
      <template #OperationColumnslot='scope'>
        <el-tooltip effect='dark' content='重新上传' placement='top-start' v-if='showCheckPower'>
          <el-button type='primary' circle style='padding: 4px;'
            @click='uploadICChangeBill(scope)'><i class='sys sys-uploaddocument'></i>
          </el-button>
        </el-tooltip>
        <el-tooltip effect='dark' content='删除' placement='top-start' v-if='showDeleteBatchNoChangePower && scope.data.row.Status === "0"'>
          <el-button type='danger' circle style='padding: 4px;'
            @click='deletedBatchNoChangeBill(scope)'><i class='sys sys-delete'></i>
          </el-button>
        </el-tooltip>
        <el-tooltip effect='dark' content='关联标签' placement='top-start'>
          <el-button type='primary' circle style='padding: 4px;'
            @click='showQRCodesDialogMD(scope)'><i class='wms wms-qrcode'></i>
          </el-button>
        </el-tooltip>
      </template>
      <template #expand='scope'>
        <div class='expand'>
          <div class='expand-inner'>
            <div class='expand-row' style='font-weight: 800; min-width: 60px; text-align: right;'><span style='color: #42426F;'>行号</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 80px; text-align: left;'><span style='color: #42426F;'>物料类型</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 200px; text-align: left;'><span style='color: #42426F;'>料号</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 200px; text-align: left;'><span style='color: #42426F;'>名称</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 350px; text-align: left;'><span style='color: #42426F;'>规格</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 100px; text-align: right;'><span style='color: #42426F;'>数量</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 100px; text-align: left;'><span style='color: #42426F;'>批号</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 120px; text-align: left;'><span style='color: #42426F;'>生成/采购日期</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 80px; text-align: left;'><span style='color: #42426F;'>保质期</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 100px; text-align: left;'><span style='color: #42426F;'>到期日</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 150px; text-align: left;'><span style='color: #42426F;'>仓库</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 120px; text-align: left;'><span style='color: #42426F;'>仓位代码</span></div>
          </div>
        </div>
        <div class='expand'>
          <div v-for='icce in scope.data.row.detailDt1'
            :key='icce.EntryID' class='expand-inner'>
            <div class='expand-row' style='min-width: 60px; text-align: right;'><span style='color: blue;'>{{icce.EntryID}} </span></div>
            <div class='expand-row' style='min-width: 80px; text-align: left;'><span style='color: blue;'>{{showExpandTransformSpecialString('MtrlType', icce.MtrlType)}} </span></div>
            <div class='expand-row' style='min-width: 200px; text-align: left;'><span style='color: blue;'>{{icce.ItemNumber}} </span></div>
            <div class='expand-row' style='min-width: 200px; text-align: left;'><span style='color: blue;'>{{icce.ItemName}} </span></div>
            <div class='expand-row' style='min-width: 350px; text-align: left;'><span style='color: blue;'>{{icce.ItemModel}} </span></div>
            <div class='expand-row' style='min-width: 100px; text-align: right;'><span style='color: blue;'>{{icce.Qty}}{{icce.UnitName}} </span></div>
            <div class='expand-row' style='min-width: 100px; text-align: left;'><span style='color: blue;'>{{icce.BatchNo}} </span></div>
            <div class='expand-row' style='min-width: 120px; text-align: left;'>
              <span style='color: blue;'>
                {{!icce.KFDate ? '' : dateTimeUtil.formartDateTime(new Date(icce.KFDate), 'yyyy-MM-dd')}}
              </span>
            </div>
            <div class='expand-row' style='min-width: 80px; text-align: left;'><span style='color: blue;'>{{icce.KFPeriod}} </span></div>
            <div class='expand-row' style='min-width: 100px; text-align: left;'>
              <span style='color: blue;'>
                {{!icce.DueDate ? '' : dateTimeUtil.formartDateTime(new Date(icce.DueDate), 'yyyy-MM-dd')}}
              </span>
            </div>
            <div class='expand-row' style='min-width: 150px; text-align: left;'><span style='color: blue;'>{{icce.StockName}} </span></div>
            <div class='expand-row' style='min-width: 120px; text-align: left;'><span style='color: blue;'>{{icce.SPNumber}} </span></div>
          </div>
        </div>
      </template>
    </Table>

    <!-- 调整批号申请 -->
    <el-dialog title='调整批号申请' :visible.sync='showBatchNoChangeDialog' fullscreen>
      <div style='margin-top: -30px; height: 30px;'>
        <div class='inputField-label' style='width: 60px; text-align: left'>
          部门
        </div>
        <el-select v-model='batchNoChangeInfo.DeptID' placeholder='请选择'
          class='inputField-input'
          style='width: 200px;' size='mini'>
          <el-option v-for='dept in depts'
            :key='dept.DepartmentID' :label='dept.Name' :value='dept.DepartmentID'>
          </el-option>
        </el-select>
        <div class='inputField-label' style='width: 60px; text-align: left'>
          业务员
        </div>
        <TableSelect v-model='batchNoChangeInfo.EmpID'
          class='inputField-input'
          :displayValue='""' customFilterStr=" AND Deleted='0'"
          returnCode='EmployeeID' displayCode='Number' displayName='Name'
          style='width: 200px;' tableCode='BD_Employee'></TableSelect>
        <div class='inputField-label' style='width: 60px; text-align: left'>
          扫描条码
        </div>
        <el-input v-model='scanQRCode' size='mini' class='inputField-input'
          @keyup.enter.native='scanQRCodeEnterMD' style='width: 200px;'>
        </el-input>
      </div>
      <div style='margin-top: 10px; height: 30px;'>
        <div class='inputField-label' style='width: 60px; text-align: left'>
          新批号
        </div>
        <el-input v-model='newBatchNo' size='mini' class='inputField-input' style='width: 200px;'>
        </el-input>
        <div class='inputField-label' style='width: 60px; text-align: left'>
          备注
        </div>
        <el-input v-model='batchNoChangeInfo.Remark' size='mini' class='inputField-input'
          style='width: 480px;'>
        </el-input>
      </div>
      <el-table :data='scanQRCodes' border :height='getScanQRCodesTableHeight()'
        ref='scanQRCodesTable' style='margin-top: 10px;'
        :cell-style='mainTableCellStyle' row-key='GUID'
        :header-cell-style='mainTableHeaderCellStyle' size='medium'>
        <el-table-column type='index' label='序号' width='60'>
        </el-table-column>
        <el-table-column prop='QRCode' label='标签号' width='200'>
        </el-table-column>
        <el-table-column prop='BI_Number' label='物料代码' width='300'>
        </el-table-column>
        <el-table-column prop='BI_Name' label='物料名称' width='350'>
        </el-table-column>
        <el-table-column prop='BI_Model' label='规格' width='200'>
        </el-table-column>
        <el-table-column prop='Qty' label='数量' width='60'>
        </el-table-column>
        <el-table-column prop='BU_Name' label='单位' width='60'>
        </el-table-column>
        <el-table-column prop='KFDate' label='生产/采购日期' width='120'>
        </el-table-column>
        <el-table-column prop='KFPeriod' label='保质期' width='100'>
        </el-table-column>
        <el-table-column prop='BatchNo' label='批号' width='100'>
        </el-table-column>
        <el-table-column prop='OuterQRCode' label='外箱标签号' width='200'>
        </el-table-column>
        <el-table-column label='操作' width='60' fixed='right'>
          <template #default='scope'>
            <el-button type='danger' circle style='padding: 4px;'
              @click='deleteScanQRCode(scope.$index)'><i class='sys sys-delete'></i>
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class='dialogButtomCenterBtn'>
        <el-button type='primary' @click='batchNoChange()' size='mini'>申请</el-button>
        <el-button @click='showBatchNoChangeDialog = false' size='mini'>取消</el-button>
      </div>
    </el-dialog>

    <!-- 关联标签 -->
    <el-dialog v-dialogDrag title='关联标签' :visible.sync='showQRCodesDialog' width='600px'
      top='10px' lock-scroll>
      <el-table :data='qrCodes' border height='300px'
        :cell-style='{ padding: "0px" }' :header-cell-style='{ padding: "2px" }' size='medium'
        style='margin-top: -35px;'>
        <el-table-column type='index' label='序号' width='60'>
        </el-table-column>
        <el-table-column prop='QRCode' label='内箱标签号' width='200'>
        </el-table-column>
        <el-table-column prop='OuterQRCode' label='外箱标签号' width='200'>
        </el-table-column>
        <el-table-column prop='BatchNo' label='批号' width='100'>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import table from '@/components/sys/Table'
import Table from '@/components/sys/Table.vue'
import tableColumnSet from '@/components/sys/TableColumnSet'
import TableColumnSet from '@/components/sys/TableColumnSet.vue'
import tableFilterSet from '@/components/sys/TableFilterSet'
import TableFilterSet from '@/components/sys/TableFilterSet.vue'
import tableFilter from '@/components/sys/TableFilter'
import TableFilter from '@/components/sys/TableFilter.vue'
import TableFilterOutDisplay from '@/components/sys/TableFilterOutDisplay.vue'
import exportExcelHelper from '@/components/export/ExportExcelHelper'
import ExportExcel from '@/components/export/ExportExcel.vue'
import code from '@/components/sys/Code'
import power from '@/components/sys/Power'
import TableSelect from '@/components/custom/TableSelect.vue'
import { Loading } from 'element-ui'
import axiosHelper from '@/utils/axiosHelper'
import dateTimeUtil from '@/utils/dateTimeUtil'

export default {
  name: 'BatchNoChange',
  components: {
    Table: Table,
    TableColumnSet: TableColumnSet,
    TableFilterSet: TableFilterSet,
    TableFilter: TableFilter,
    TableFilterOutDisplay: TableFilterOutDisplay,
    ExportExcel: ExportExcel,
    TableSelect: TableSelect
  },
  metaInfo: function () {
    return {
      title: this.menuName
    }
  },
  data: function () {
    return {
      menuCode: '',
      menuName: '',
      mainTable: {
        tableCode: 'WMS_ICChange_Type0',
        tableInfo: {},
        columnInfo: [],
        disPlayColumnInfo: [],
        tableContent: [],
        pageSize: 50,
        page: 1,
        total: 0,
        defaultOrderStr: '',
        orderStr: '',
        defaultFilterStr: '',
        filterStr: '',
        Loading: false,

        detail1FilterStr: '',
        itemNumber: '',
        itemName: '',
        detail2FilterStr: '',
        qrCode: '',

        userColumnInfo: [],
        userTableInfo: {},
        showColumnSetDialog: false,
        changeShowColumnSetDialog: false,
        ColumnSetLoading: false,

        userFilterInfo: [],
        showFilterSetDialog: false,
        changeShowFilterSetDialog: false,
        FilterSetLoading: false,

        filterInfo: [],
        showFilterDialog: false,
        changeShowFilterDialog: false,
        FilterLoading: false,

        selections: [],
        expandRowKeys: []
      },

      dateTimeUtil: dateTimeUtil,

      mtrlTypes: [],

      showBatchNoChangeDialog: false,
      batchNoChangeInfo: {
        DeptID: '',
        EmpID: '',
        ClassType: '1007001',
        Remark: '',
        ChangeType: '0'
      },
      scanQRCode: '',
      scanQRCodes: [],
      newBatchNo: '',
      depts: [],

      showQRCodesDialog: false,
      qrCodes: [],
      icChangeBill: {},

      showBatchNoChangePower: false,
      showDeleteBatchNoChangePower: false,
      showCheckPower: false,
      showUnCheckPower: false
    }
  },

  computed: {
    codes: function () {
      return this.$store.state.codes
    }
  },

  created: async function () {
    const that = this
    that.menuCode = that.$route.path.substring(1)
    that.menuName = that.$route.meta.title
    power.setPower(that)
    const codes = that.codes
    that.mtrlTypes = code.getCode(codes, 'WMS_ICChangeEntry_MtrlType')
    const tableContentPromise = table.refreshTableStructure(that, 'mainTable')
    const tableFilterInfoPromise = tableFilter.refreshTableFliter(that, 'mainTable')
    const deptObjPromise = table.getTableContent('BD_Department', 10000, 1, '', " AND Deleted='0'")

    await tableContentPromise
    await tableFilterInfoPromise
    const deptObj = await deptObjPromise
    that.depts = deptObj.tableContent
  },

  methods: {
    // 页面主表格深度刷新方法
    deepRefreshMainTableContent: function () {
      const that = this
      that.mainTable.filterStr = that.mainTable.defaultFilterStr
      that.mainTable.orderStr = that.mainTable.defaultOrderStr
      that.refreshMainTableContent()
    },

    // 页面主表格刷新方法
    refreshMainTableContent: function () {
      const that = this
      table.refreshTableContent(that, 'mainTable')
    },

    // 页面主表格换页方法
    mainTablePageChange: function (val) {
      const that = this
      that.mainTable.page = val
      that.refreshMainTableContent()
    },

    // 页面主表格改变每页显示数据条数方法
    mainTableSizeChange: function (val) {
      const that = this
      that.mainTable.page = 1
      that.mainTable.pageSize = val
      that.refreshMainTableContent()
    },

    // 页面主表格排序方式变更方法
    mainTableSortChange: function (column) {
      const that = this
      table.sortChange(column, that, 'mainTable')
    },

    // 页面主表格多选方法
    mainTableSelectionChange: function (selections, row) {
      const that = this
      that.mainTable.selections = selections
    },

    // 页面主表格过滤弹出框显示方法
    mainTableShowFilterDialogMD: function () {
      const that = this
      tableFilter.showTableFliter(that, 'mainTable')
    },

    // 页面主表格过滤方法
    mainTableFilter: function () {
      const that = this
      let detail1FilterStr = ''
      if (that.mainTable.itemNumber) {
        const itemNumbers = that.mainTable.itemNumber.replace(/，/g, ',').split(',')
        detail1FilterStr += ' AND (1=0 '
        for (let i = 0; i < itemNumbers.length; i++) {
          detail1FilterStr += " OR ItemNumber LIKE'%" + itemNumbers[i] + "%'"
        }
        detail1FilterStr += ')'
      }
      if (that.mainTable.itemName) {
        const itemNames = that.mainTable.itemName.replace(/，/g, ',').split(',')
        detail1FilterStr += ' AND (1=0 '
        for (let i = 0; i < itemNames.length; i++) {
          detail1FilterStr += " OR ItemName LIKE'%" + itemNames[i] + "%'"
        }
        detail1FilterStr += ')'
      }
      that.mainTable.detail1FilterStr = detail1FilterStr
      let detail2FilterStr = ''
      if (that.mainTable.qrCode) {
        const qrCodes = that.mainTable.qrCode.replace(/，/g, ',').split(',')
        detail2FilterStr += ' AND (1=0 '
        for (let i = 0; i < qrCodes.length; i++) {
          detail2FilterStr += " OR QRCode LIKE'%" + qrCodes[i] + "%'"
        }
        detail2FilterStr += ')'
      }
      that.mainTable.detail2FilterStr = detail2FilterStr
      tableFilter.filter(that, 'mainTable')
    },

    // 页面主表格栏目设置弹框显示方法
    mainTableShowColumnSetDialogMD: function () {
      const that = this
      tableColumnSet.showTableColumnSet(that, 'mainTable')
    },

    // 页面主表格栏目设置重置方法
    mainTableUpdateUserColumnSetDialogReset: function () {
      const that = this
      tableColumnSet.resetTableColumnSet(that, 'mainTable')
    },

    // 页面主表格栏目设置保存方法
    mainTableSaveUserTableColumn: function () {
      const that = this
      tableColumnSet.saveUserTableColumn(that, 'mainTable')
    },

    // 页面主表格栏目设置恢复默认方法
    mainTableReturnDefaultTableColumn: function () {
      const that = this
      tableColumnSet.returnDefaultTableColumn(that, 'mainTable')
    },

    // 页面主表格过滤设置弹框显示方法
    mainTableShowFilterSetDialogMD: function () {
      const that = this
      tableFilterSet.showTableFliterSet(that, 'mainTable')
    },

    // 页面主表格过滤设置重置方法
    mainTableUpdateUserFilterDialogReset: function () {
      const that = this
      tableFilterSet.resetTableFilterSet(that, 'mainTable')
    },

    // 页面主表格过滤设置保存方法
    mainTableSaveUserTableFilter: function () {
      const that = this
      tableFilterSet.saveUserTableFilter(that, 'mainTable')
    },

    // 页面主表格过滤设置恢复默认方法
    mainTableReturnDefaultTableFilter: function () {
      const that = this
      tableFilterSet.returnDefaultTableFilter(that, 'mainTable')
    },

    // 主表行展开方法
    mainTableExpandRow: function () {
      const that = this
      table.expandRow(that, 'mainTable')
    },

    // 主表行收起方法
    mainTableNarrowRow: function () {
      const that = this
      table.narrowRow(that, 'mainTable')
    },

    // 特征字符串转换方法
    mainTableGetSpecialStringArray: function (columnCode) {
      return []
    },

    // 页面主表格行样式设定方法
    mainTableRowStyle: function (data, rowIndex) {
      if (data.row.Status === '1' && data.row.HaveToErp !== '1') {
        return { 'background-color': 'red' }
      } else if (data.row.Status === '0') {
        return { 'background-color': 'orange' }
      } else {
        return {}
      }
    },

    // 主表数据导出为Excel
    mainTableExportExcel: function () {
      const that = this
      exportExcelHelper.exportSYSTableToExcel(that, 'mainTable')
    },

    // 展开明细特征字符串转换方法
    showExpandTransformSpecialString: function (columnCode, val) {
      const that = this
      if (columnCode === 'MtrlType') {
        return table.specialStringDisplayTransform(val, that.mtrlTypes)
      }
      return val
    },

    // 批号调整申请弹出框显示方法
    showBatchNoChangeDialogMD: function () {
      const that = this
      that.scanQRCodes = []
      that.newBatchNo = ''
      that.batchNoChangeInfo.ClassType = '1007001'
      that.batchNoChangeInfo.Remark = ''
      that.batchNoChangeInfo.ChangeType = '0'
      that.showBatchNoChangeDialog = true
    },

    // 获取其他入库扫描标签表格高度
    getScanQRCodesTableHeight: function () {
      return window.innerHeight - 200 + 'px'
    },

    // 表格单元格样式
    mainTableCellStyle: function () {
      return { padding: '0px' }
    },

    // 表格表头单元格样式
    mainTableHeaderCellStyle: function ({ column, columnIndex, row, rowIndex }) {
      return { padding: '5px', 'background-color': '#f5f7fa' }
    },

    // 扫码方法
    scanQRCodeEnterMD: async function () {
      const that = this
      if (!that.scanQRCode) {
        return
      }
      const loadingInstance = Loading.service({ fullscreen: true })
      let qrCodeObj = null
      if (that.scanQRCode.indexOf('|') > 0) {
        that.scanQRCode = that.scanQRCode.substring(0, that.scanQRCode.indexOf('|'))
      }
      let addNum = 0
      qrCodeObj = await axiosHelper.handle('/WebAction/WarehouseManage.Inventory.GetQRCode', {
        qrCode: that.scanQRCode
      })
      if (qrCodeObj.error === '000000') {
        if (qrCodeObj.tableContent.length <= 0) {
          loadingInstance.close()
          that.$message.error('该标签号不存在！')
          that.scanQRCode = ''
          return
        }
        for (let i = 0; i < qrCodeObj.tableContent.length; i++) {
          if (qrCodeObj.tableContent[i].Status !== '1') {
            continue
          } else {
            if (!qrCodeObj.tableContent[i].BatchNo) {
              loadingInstance.close()
              that.$message.error('请扫描有批号的标签！')
              return
            }
            let haveScanFlag = false
            for (let j = 0; j < that.scanQRCodes.length; j++) {
              if (that.scanQRCodes[j].QRCode === qrCodeObj.tableContent[i].QRCode) {
                haveScanFlag = true
              }
            }
            if (haveScanFlag) {
              qrCodeObj.tableContent[i].haveScanFlag = true
            }
          }
        }
        for (let i = 0; i < qrCodeObj.tableContent.length; i++) {
          if (qrCodeObj.tableContent[i].Status !== '1') {
            continue
          }
          if (qrCodeObj.tableContent[i].haveScanFlag) {
            addNum++
            continue
          }
          if (that.scanQRCodes.length > 0) {
            if (qrCodeObj.tableContent[i].ItemID !== that.scanQRCodes[0].ItemID) {
              loadingInstance.close()
              that.$message.error('请扫描相同物料的标签！')
              return
            }
            if (qrCodeObj.tableContent[i].UnitID !== that.scanQRCodes[0].UnitID) {
              loadingInstance.close()
              that.$message.error('请扫描相同单位的标签！')
              return
            }
            if (qrCodeObj.tableContent[i].KFDate !== that.scanQRCodes[0].KFDate) {
              loadingInstance.close()
              that.$message.error('请扫描相同生产日期的标签！')
              return
            }
            if (qrCodeObj.tableContent[i].KFPeriod !== that.scanQRCodes[0].KFPeriod) {
              loadingInstance.close()
              that.$message.error('请扫描相同保质期的标签！')
              return
            }
            if (qrCodeObj.tableContent[i].MTONo !== that.scanQRCodes[0].MTONo) {
              loadingInstance.close()
              that.$message.error('请扫描相同计划跟踪号的标签！')
              return
            }
            if (qrCodeObj.tableContent[i].SPID !== that.scanQRCodes[0].SPID) {
              loadingInstance.close()
              that.$message.error('请扫描相同仓位的标签！')
              return
            }
            if (qrCodeObj.tableContent[i].StockID !== that.scanQRCodes[0].StockID) {
              loadingInstance.close()
              that.$message.error('请扫描相同仓库的标签！')
              return
            }
          }
          that.scanQRCodes.push(qrCodeObj.tableContent[i])
          addNum++
        }
        that.scanQRCode = ''
        if (addNum <= 0) {
          loadingInstance.close()
          that.$message.error('该标签号中的没有在库的内箱标签！')
          return
        }
      } else {
        that.$message.error('网络异常！')
      }
      loadingInstance.close()
    },

    // 删除已扫描
    deleteScanQRCode: function (index) {
      const that = this
      that.scanQRCodes.splice(index, 1)
    },

    // 调整批号申请
    batchNoChange: async function () {
      const that = this
      if (!that.batchNoChangeInfo.DeptID) {
        that.$message.error('请选择部门！')
        return
      }
      if (!that.batchNoChangeInfo.EmpID) {
        that.$message.error('请选择业务员！')
        return
      }
      if (!that.newBatchNo) {
        that.$message.error('请输入新批号！')
        return
      }
      if (that.scanQRCodes.length <= 0) {
        that.$message.error('请扫码！')
        return
      }

      const loadingInstance = Loading.service({ fullscreen: true })
      const rtnObj = await axiosHelper.handle('/WebAction/WarehouseManage.Inventory.BatchNoChange', {
        newBatchNo: that.newBatchNo,
        batchNoChangeInfo: that.batchNoChangeInfo,
        qrCodes: that.scanQRCodes
      })
      if (rtnObj.error === '000000') {
        that.refreshMainTableContent()
        that.showBatchNoChangeDialog = false
        if (rtnObj.msg) {
          that.$message.warning('申请成功，但是有异常信息！【' + rtnObj.msg + '】')
        } else {
          that.$message.success('申请成功！')
        }
      } else {
        that.$message.error(rtnObj.msg)
      }
      loadingInstance.close()
    },

    // 删除批号调整申请
    deletedBatchNoChangeBill: function (scope) {
      const that = this
      that.$confirm('确定要删除该批号调整申请单吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const loadingInstance = Loading.service({ fullscreen: true })
        const rtnObj = await axiosHelper.handle('/WebAction/WarehouseManage.Inventory.DeleteBatchNoChange', {
          icChangeNo: scope.data.row.ICChangeNo
        })
        if (rtnObj.error === '000000') {
          that.refreshMainTableContent()
          that.$message.success('删除成功！')
        } else {
          that.$message.error(rtnObj.msg)
        }
        loadingInstance.close()
      }).catch(() => {
      })
    },

    // 关联标签显示方法
    showQRCodesDialogMD: async function (scope) {
      const that = this
      that.qrCodes = scope.data.row.detailDt2
      that.icChangeBill = scope.data.row
      that.showQRCodesDialog = true
    },

    // 审核
    checkICC: async function () {
      const that = this
      if (that.mainTable.selections.length <= 0) {
        that.$message.error('请选择数据！')
        return
      }
      for (let i = 0; i < that.mainTable.selections.length; i++) {
        if (that.mainTable.selections[i].Status !== '0') {
          that.$message.error('请选择未审核数据！')
          return
        }
      }
      const loadingInstance = Loading.service({ fullscreen: true })
      const rtnObj = await axiosHelper.handle('/WebAction/WarehouseManage.Inventory.CheckBatchNoChange', {
        iccs: that.mainTable.selections
      })
      if (rtnObj.error === '000000') {
        that.refreshMainTableContent()
        if (rtnObj.msg) {
          that.$message.warning('审核成功！但有异常信息：' + rtnObj.msg)
        } else {
          that.$message.success('审核成功！')
        }
      } else {
        that.$message.error(rtnObj.msg)
      }
      loadingInstance.close()
    },

    // 反审核
    cancelCheckICC: async function () {
      const that = this
      if (that.mainTable.selections.length <= 0) {
        that.$message.error('请选择数据！')
        return
      }
      for (let i = 0; i < that.mainTable.selections.length; i++) {
        if (that.mainTable.selections[i].Status !== '1') {
          that.$message.error('请选择已审核数据！')
          return
        }
      }
      const loadingInstance = Loading.service({ fullscreen: true })
      const rtnObj = await axiosHelper.handle('/WebAction/WarehouseManage.Inventory.UnCheckBatchNoChange', {
        iccs: that.mainTable.selections
      })
      if (rtnObj.error === '000000') {
        that.refreshMainTableContent()
        that.$message.success('反审核成功！')
      } else {
        that.$message.error(rtnObj.msg)
      }
      loadingInstance.close()
    },

    // 重新上传批次调整单至金蝶
    uploadICChangeBill: async function (scope) {
      const that = this
      const loadingInstance = Loading.service({ fullscreen: true })
      const rtnObj = await axiosHelper.handle('/WebAction/UploadToERP.UploadICStockBill.UploadICChange', {
        billNo: scope.data.row.ICChangeNo
      })
      if (rtnObj.error === '000000') {
        that.refreshMainTableContent()
        that.$message.success('重新上传成功！')
      } else {
        that.$message.error(rtnObj.msg)
      }
      loadingInstance.close()
    }
  }
}
</script>

<style scoped>
.navbar {
  padding-bottom: 0px;
  width: 100%;
  padding: 0;
  margin-bottom: 5px;
  margin-top: -10px;
}
.dialogButtomCenterBtn {
  margin-top: 10px;
  text-align: center;
  display: flex;
  flex-direction: row;
  justify-content: center;
}
.expand {
  padding-left: 46px;
}
.expand-inner {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
}
.expand-row {
  margin-right: 10px;
  padding-left: 20p;
  color: blue;
  white-space: nowrap;
}
.filterInput {
  margin-right: 10px;
  margin-top: 6px;
}
.tableInput {
  height: 26px;
  line-height: 26px;
  border: 0px #FFFFFF;
  background-color: transparent;
}
.inputField-label {
  font-size: 14px;
  color: #606266;
  padding-right: 10px;
  vertical-align: middle;
  line-height: 28px;
  float: left;
}
.inputField-input {
  margin-right: 10px;
  float: left;
}
</style>
